// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"994016ec","419":"50c240e6","496":"ea90aee5","571":"5f982530","905":"eba1eb21"}[chunkId] + ".chunk.js";
};